import React, { useState, useEffect } from 'react';
import { db } from '../firebase/firestore';
import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import Spinner from '../Components/Spinner';

const AdminFaqPanelComponent = () => {
  const [faqs, setFaqs] = useState([]);
  const [terms, setTerms] = useState([]);
  const [loading, setLoading] = useState(true);

  // New FAQ inputs
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  // New Term inputs
  const [termTitle, setTermTitle] = useState('');
  const [termContent, setTermContent] = useState('');

  // ---------------- FETCH ----------------
  const fetchContent = async () => {
    setLoading(true);
    try {
      const faqSnap = await getDocs(collection(db, "faq"));
      setFaqs(faqSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      const termSnap = await getDocs(collection(db, "terms"));
      setTerms(termSnap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (err) {
      console.error("Ошибка при загрузке контента:", err);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchContent();
  }, []);
  

  // ---------------- ADD ----------------
  const handleAddFaq = async () => {
    if (!question || !answer) return alert("Fill in both fields for FAQ");
    try {
      await addDoc(collection(db, "faq"), { question, answer, createdAt: new Date() });
      setQuestion('');
      setAnswer('');
      fetchContent();
    } catch (err) {
      console.error("Ошибка добавления FAQ:", err);
    }
  };

  const handleAddTerm = async () => {
    if (!termTitle || !termContent) return alert("Fill in both fields for Term");
    try {
      await addDoc(collection(db, "terms"), { title: termTitle, content: termContent, createdAt: new Date() });
      setTermTitle('');
      setTermContent('');
      fetchContent();
    } catch (err) {
      console.error("Ошибка добавления Term:", err);
    }
  };

  // ---------------- DELETE ----------------
  const handleDeleteFaq = async (id) => {
    if (!window.confirm("Delete this FAQ?")) return;
    try {
      await deleteDoc(doc(db, "faq", id));
      setFaqs(prev => prev.filter(f => f.id !== id));
    } catch (err) {
      console.error("Ошибка при удалении FAQ:", err);
    }
  };

  const handleDeleteTerm = async (id) => {
    if (!window.confirm("Delete this Term?")) return;
    try {
      await deleteDoc(doc(db, "terms", id));
      setTerms(prev => prev.filter(t => t.id !== id));
    } catch (err) {
      console.error("Ошибка при удалении Term:", err);
    }
  };

  // ---------------- UPDATE ----------------
  const handleUpdateFaq = async (id, newQuestion, newAnswer) => {
    try {
      await updateDoc(doc(db, "faq", id), { question: newQuestion, answer: newAnswer });
      fetchContent();
    } catch (err) {
      console.error("Ошибка при обновлении FAQ:", err);
    }
  };

  const handleUpdateTerm = async (id, newTitle, newContent) => {
    try {
      await updateDoc(doc(db, "terms", id), { title: newTitle, content: newContent });
      fetchContent();
    } catch (err) {
      console.error("Ошибка при обновлении Term:", err);
    }
  };

  if (loading) return <Spinner />;

return (
  <div id="refer" className="min-h-screen bg-gray-900 text-white overflow-auto">
    <div className="max-w-3xl mx-auto p-6 space-y-8">
      <h1 className="text-3xl font-bold mb-4 text-center">Admin Content Panel</h1>

      {/* ---------------- ADD FAQ ---------------- */}
      <div className="space-y-2 bg-gray-800 p-4 rounded-lg">
        <h2 className="text-xl font-semibold text-white mb-2">Add New FAQ</h2>
        <input
          type="text"
          placeholder="Question"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
        />
        <textarea
          placeholder="Answer"
          value={answer}
          onChange={(e) => setAnswer(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
        />
        <button
          onClick={handleAddFaq}
          className="bg-cyan-500 text-white px-4 py-2 rounded hover:bg-cyan-600"
        >
          Add FAQ
        </button>
      </div>

      {/* ---------------- FAQ LIST ---------------- */}
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-white mb-2">FAQs</h2>
        {faqs.map(faq => (
          <EditableItem
            key={faq.id}
            item={faq}
            type="faq"
            onDelete={handleDeleteFaq}
            onUpdate={handleUpdateFaq}
          />
        ))}
      </div>

      {/* ---------------- ADD TERM ---------------- */}
      <div className="space-y-2 bg-gray-800 p-4 rounded-lg">
        <h2 className="text-xl font-semibold text-white mb-2">Add New Term</h2>
        <input
          type="text"
          placeholder="Title"
          value={termTitle}
          onChange={(e) => setTermTitle(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
        />
        <textarea
          placeholder="Content"
          value={termContent}
          onChange={(e) => setTermContent(e.target.value)}
          className="w-full p-2 rounded bg-gray-700 text-white"
        />
        <button
          onClick={handleAddTerm}
          className="bg-cyan-500 text-white px-4 py-2 rounded hover:bg-cyan-600"
        >
          Add Term
        </button>
      </div>

      {/* ---------------- TERMS LIST ---------------- */}
      <div className="space-y-2">
        <h2 className="text-xl font-semibold text-white mb-2">Terms</h2>
        {terms.map(term => (
          <EditableItem
            key={term.id}
            item={term}
            type="term"
            onDelete={handleDeleteTerm}
            onUpdate={handleUpdateTerm}
          />
        ))}
      </div>
    </div>
  </div>
);
};

// ---------------- EditableItem ----------------
const EditableItem = ({ item, type, onDelete, onUpdate }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [field1, setField1] = useState(type === "faq" ? item.question : item.title);
  const [field2, setField2] = useState(type === "faq" ? item.answer : item.content);

return (
    <div className="bg-gray-900 p-3 rounded flex flex-col space-y-2 h-full max-h-full overflow-y-auto">
      {isEditing ? (
        <>
          <input
            value={field1}
            onChange={(e) => setField1(e.target.value)}
            className="w-full p-2 rounded bg-gray-700 text-white"
            placeholder={type === "faq" ? "Question" : "Title"}
          />
          <textarea
            value={field2}
            onChange={(e) => setField2(e.target.value)}
            className="w-full p-2 rounded bg-gray-700 text-white"
            placeholder={type === "faq" ? "Answer" : "Content"}
          />
          <div className="flex gap-2 justify-end">
            <button
              onClick={() => { onUpdate(item.id, field1, field2); setIsEditing(false); }}
              className="bg-green-600 px-3 py-1 rounded text-white hover:bg-green-700"
            >
              Save
            </button>
            <button
              onClick={() => setIsEditing(false)}
              className="bg-gray-600 px-3 py-1 rounded text-white hover:bg-gray-700"
            >
              Cancel
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="font-semibold text-white">{type === "faq" ? item.question : item.title}</p>
          <p className="text-gray-300">{type === "faq" ? item.answer : item.content}</p>
          <div className="flex gap-2 justify-end">
            <button
              onClick={() => setIsEditing(true)}
              className="bg-cyan-500 px-3 py-1 rounded text-white hover:bg-cyan-600"
            >
              Edit
            </button>
            <button
              onClick={() => onDelete(item.id)}
              className="bg-red-600 px-3 py-1 rounded text-white hover:bg-red-700"
            >
              Delete
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminFaqPanelComponent;
